import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';  // ✅ Added useNavigate
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,             // profile icon
  faFileAlt,          // application details icon
  faLayerGroup,       // feature management icon
  faCloudUploadAlt    // backup & restore icon
} from '@fortawesome/free-solid-svg-icons';

const SettingsSidebar: React.FC = () => {
  const navigate = useNavigate(); 

  const sidebarItems = [
    { id: 'profile', label: 'Profile', icon: faUser, path: 'profile' },
    // { id: 'application', label: 'Application details', icon: faFileAlt, path: 'application-details' },
    { id: 'feature', label: 'Feature management', icon: faLayerGroup, path: 'feature-management' },
    // { id: 'backup', label: 'Backup & Restore', icon: faCloudUploadAlt, path: 'backup-restore' }
  ];

  return (
    <div className="settings-sidebar-container">
      <div className="settings-sidebar">
        <div className="settings-sidebar-header">
          <button onClick={() => navigate('/dashboard/uiConfig')} className="settings-back-btn">  {/* ✅ Changed this line */}
            <span className="settings-back-icon">←</span>
          </button>
          <h2 className="settings-sidebar-title">Settings</h2>
        </div>

        <nav className="settings-sidebar-nav">
          {sidebarItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `settings-sidebar-item ${isActive ? 'active' : ''}`
              }
            >
              <FontAwesomeIcon
                icon={item.icon}
                className="settings-sidebar-icon"
              />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SettingsSidebar;
